import { render } from "./EventArticlesOverTime.vue?vue&type=template&id=312dd8f4"
import script from "./EventArticlesOverTime.vue?vue&type=script&lang=js"
export * from "./EventArticlesOverTime.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__